var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGPayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 218",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    alt: "Google Pay logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.504 42.169c-25.25-14.576-57.538-5.915-72.13 19.336l-36.782 63.717c-10.643 18.4 3.059 24.829 18.337 33.99l35.393 20.427c11.986 6.914 27.295 2.81 34.208-9.16l37.813-65.482c12.702-22.004 5.165-50.125-16.839-62.828Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m190.884 68.542-35.393-20.428c-19.538-10.846-30.603-11.564-38.624 1.186l-52.201 90.404c-14.576 25.234-5.9 57.507 19.335 72.051 22.004 12.703 50.126 5.166 62.829-16.838l53.2-92.152c6.944-11.985 2.84-27.31-9.146-34.223Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.697 22.069 172.837 7.71c-27.497-15.87-62.657-6.46-78.528 21.037l-47.332 81.976c-6.991 12.095-2.84 27.576 9.255 34.551l27.84 16.074c13.748 7.944 31.32 3.23 39.264-10.518l54.073-93.65c11.205-19.397 36.003-26.045 55.4-14.84l-35.112-20.272Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.033 52.203 74.16 36.722c-11.985-6.898-27.294-2.81-34.207 9.145L7.71 101.579c-15.87 27.419-6.46 62.5 21.037 78.325l20.459 11.782L74.02 205.98l10.768 6.195c-19.117-12.796-25.188-38.436-13.5-58.63l8.35-14.42 30.571-52.825c6.898-11.923 2.794-27.2-9.176-34.098Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGPayIcon);
export default __webpack_public_path__ + "static/media/gPayIcon.a4d9353973a0a9180d245efe28d27b53.svg";
export { ForwardRef as ReactComponent };